import { motion } from "motion/react";

export const Tagline = () => {
  return (
    <div className=" h-screen w-screen flex justify-end items-center lg:p-24 md:p-16 p-8">
      <div className="w-fit h-1/2 flex flex-col justify-center items-end text-4xl sm:text-5xl lg:text-[64px] font-gilroy-regular leading-[1] relative">
        <div className=" hidden lg:block  ">
          <div>
            <span>From </span>
            <span className=" font-nyght-serif-light-italic ">
              spatial design
            </span>
            <span> to </span>
            <span className=" font-nyght-serif-light-italic ">
              sensory depth
            </span>
          </div>
          <div> every detail crafted to evoke </div>
          <div>
            <span className=" font-nyght-serif-light-italic "> emotion </span>
            <span> and </span>
            <span className=" font-nyght-serif-light-italic ">
              spark connection
            </span>
            <span className="  lg:size-[10px] md:size-[8px] sm:size-[6px] size-[4px] text-[#FB2C36] rounded-full lg:mt-4 mt-3 ml-1">.</span>
          </div>
        </div>
        <TaglineMobile />
        {/* Glass distortion effect using pseudo-element structure */}
        <motion.div
          className="absolute hidden lg:block w-[250px] h-[250px] rounded-full pointer-events-none"
          style={{
            isolation: "isolate",
            zIndex: 10,
          }}
          initial={{
            top: "50%",
            left: "0%",
            translateX: "calc(calc(2/3*  100%) * (-1))",
            translateY: "calc(calc(1/2*  100%) * (-1))",
          }}
          animate={{
            top: ["50%", "0%", "100%", "50%"],
            left: ["0%", "70%", "70%", "0%"],
            translateY: [
              "calc(calc(1/2*  100%) * (-1))",
              "calc(calc(2/3*  100%) * (-1))",
              "calc(calc(1/3*  100%) * (-1))",
              "calc(calc(1/2*  100%) * (-1))",
            ],
          }}
          transition={{
            duration: 15,
            ease: "easeInOut",
            repeat: Infinity,
          }}
        >
          {/* Tint and shadow layer */}
          <div
            className="absolute inset-0 rounded-full pointer-events-none"
            style={{
              boxShadow: "inset 0 0 20px -5px rgba(255,255,255,0.7)",
              // backgroundColor: "rgba(255,0,0,0.1)",
              zIndex: 1,
            }}
          />
          {/* Frosted glass + distortion layer */}
          <div
            className="absolute inset-0 rounded-full pointer-events-none"
            style={{
              backdropFilter: "blur(2px)",
              WebkitBackdropFilter: "blur(2px)",
              filter: "url(#glass-distortion)",
              WebkitFilter: "url(#glass-distortion)",
              zIndex: 0,
              isolation: "isolate",
            }}
          />
          {/* SVG filter definition */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="0"
            height="0"
            style={{ position: "absolute", overflow: "hidden" }}
          >
            <defs>
              <filter
                id="glass-distortion"
                x="0%"
                y="0%"
                width="100%"
                height="100%"
              >
                <feTurbulence
                  type="fractalNoise"
                  baseFrequency="0.008 0.008"
                  numOctaves="2"
                  seed="92"
                  result="noise"
                />
                <feGaussianBlur in="noise" stdDeviation="2" result="blurred" />
                <feDisplacementMap
                  in="SourceGraphic"
                  in2="blurred"
                  scale="77"
                  xChannelSelector="R"
                  yChannelSelector="G"
                />
              </filter>
            </defs>
          </svg>
        </motion.div>
      </div>
    </div>
  );
};

const TaglineMobile = () => {
  return (
    <div className=" block lg:hidden text-right ">
      <span>From </span>
      <span className=" font-nyght-serif-light-italic ">spatial design</span>
      <span> to </span>
      <span className=" font-nyght-serif-light-italic ">sensory depth</span>
      <span> every detail crafted to evoke </span>
      <span className=" font-nyght-serif-light-italic "> emotion </span>
      <span> and </span>
      <span className=" font-nyght-serif-light-italic ">spark connection</span>
      <span className="  lg:size-[10px] md:size-[8px] sm:size-[6px] size-[4px] bg-red-500 rounded-full lg:mt-4 mt-3 ml-1"></span>
    </div>
  );
};
